import { render, staticRenderFns } from "./onInput-editor.vue?vue&type=template&id=f33bd8b8&scoped=true"
import script from "./onInput-editor.vue?vue&type=script&lang=js"
export * from "./onInput-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33bd8b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f33bd8b8')) {
      api.createRecord('f33bd8b8', component.options)
    } else {
      api.reload('f33bd8b8', component.options)
    }
    module.hot.accept("./onInput-editor.vue?vue&type=template&id=f33bd8b8&scoped=true", function () {
      api.rerender('f33bd8b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/event-handler/onInput-editor.vue"
export default component.exports